'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ExampleContentModel = exports.ExampleSubContentModel = undefined;

var _defineProperty = require('babel-runtime/core-js/object/define-property');

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _desc, _value, _class, _descriptor, _descriptor2, _descriptor3, _class2, _temp2, _dec, _dec2, _desc2, _value2, _class3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _class4, _temp4;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _mobx = require('mobx');

var _mobxReact = require('mobx-react');

var _deepBindDecorator = require('deep-bind-decorator');

var _deepBindDecorator2 = _interopRequireDefault(_deepBindDecorator);

var _baseComponent = require('base-component');

var _baseComponent2 = _interopRequireDefault(_baseComponent);

var _baseContentmodel = require('base-contentmodel');

var _baseContentmodel2 = _interopRequireDefault(_baseContentmodel);

var _component = require('./component');

var _component2 = _interopRequireDefault(_component);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var ExampleSubContentModel = exports.ExampleSubContentModel = (_class = (_temp2 = _class2 = function (_BaseContentModel) {
  (0, _inherits3.default)(ExampleSubContentModel, _BaseContentModel);

  function ExampleSubContentModel() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ExampleSubContentModel);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ExampleSubContentModel.__proto__ || (0, _getPrototypeOf2.default)(ExampleSubContentModel)).call.apply(_ref, [this].concat(args))), _this), _initDefineProp(_this, 'text', _descriptor, _this), _initDefineProp(_this, 'richText', _descriptor2, _this), _initDefineProp(_this, 'userInput', _descriptor3, _this), _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ExampleSubContentModel, null, [{
    key: '_defaults',
    get: function get() {
      return {
        text: "This is the default text for this content model",
        richText: "<h1>Title</h1><br/>Some <b><i>Rich</i></b> text."
      };
    }

    /* @slot */

    /* @slot("RichText") */
  }]);
  return ExampleSubContentModel;
}(_baseContentmodel2.default), _class2._slots = {
  text: "",
  richText: "RichText"
}, _temp2), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'text', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return "Default text";
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, 'richText', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return "Default text for richText";
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, 'userInput', [_mobx.observable, _deepBindDecorator2.default], {
  enumerable: true,
  initializer: function initializer() {
    return {
      get variable() {
        return 'G:' + this.id + '_userInput:G';
      },
      defaultValue: "another default"
    };
  }
})), _class);
var ExampleContentModel = exports.ExampleContentModel = (_dec = _mobx.observable.ref, _dec2 = _mobx.observable.shallow, (_class3 = (_temp4 = _class4 = function (_BaseContentModel2) {
  (0, _inherits3.default)(ExampleContentModel, _BaseContentModel2);

  function ExampleContentModel() {
    var _ref2;

    var _temp3, _this2, _ret2;

    (0, _classCallCheck3.default)(this, ExampleContentModel);

    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return _ret2 = (_temp3 = (_this2 = (0, _possibleConstructorReturn3.default)(this, (_ref2 = ExampleContentModel.__proto__ || (0, _getPrototypeOf2.default)(ExampleContentModel)).call.apply(_ref2, [this].concat(args))), _this2), _initDefineProp(_this2, '_options', _descriptor4, _this2), _this2.Component = _component2.default, _initDefineProp(_this2, 'textSlot', _descriptor5, _this2), _initDefineProp(_this2, 'richTextSlot', _descriptor6, _this2), _initDefineProp(_this2, 'textOptionsSlot', _descriptor7, _this2), _initDefineProp(_this2, 'numberSlot', _descriptor8, _this2), _initDefineProp(_this2, 'booleanSlot', _descriptor9, _this2), _initDefineProp(_this2, 'referenceSlot', _descriptor10, _this2), _initDefineProp(_this2, 'referenceArraySlot', _descriptor11, _this2), _initDefineProp(_this2, 'isCompleted', _descriptor12, _this2), _initDefineProp(_this2, 'userInput', _descriptor13, _this2), _initDefineProp(_this2, 'userInput_computed', _descriptor14, _this2), _initDefineProp(_this2, 'customUserInput', _descriptor15, _this2), _temp3), (0, _possibleConstructorReturn3.default)(_this2, _ret2);
  }
  // the ContentModel classes contain the customizable "slots" that content creators will be filling in
  // presently these are defined via static _slots, but will be applied via @slot sugar
  // see the list below for examples of the slot types, and the editor input created for each:


  (0, _createClass3.default)(ExampleContentModel, null, [{
    key: '_defaults',
    get: function get() {
      return {
        textSlot: "Some default text",
        richTextSlot: "Default RichText",
        textOptionsSlot: "Option1",
        numberSlot: 8,
        booleanSlot: false,
        referenceSlot: new ExampleSubContentModel(ExampleSubContentModel._defaults),
        referenceArraySlot: [new ExampleSubContentModel(ExampleSubContentModel._defaults), new ExampleSubContentModel(ExampleSubContentModel._defaults)]
      };
    }

    // options are a way to supply slots with specific options
    // this is currently defined manually, but will be taken care of by @options decorator 

    // define the default Component (Sim) view of this component

    /* @slot */

    // below is what content model definitions will ultimately look like. note the commented out decorators.
    // when these are in place, you will not need @observable, @observable.ref, etc

    /* @slot("RichText") */
    /* @options(["Option1", "Option2", "Option3"]) @slot */
    /* @slot */
    /* @slot */
    /* @slot(ExampleSubContentModel) */
    /* @slot([ExampleSubContentModel]) */

    // @input userInput = 100
    // creates...

    // @input.computed userInput_computed = () => {
    // const userInput2Val = this.$inputStore.getInput(this, "userInput2")
    // return userInput2Val + " was computed ... "
    // }
    // creates...

    // @input( () => `G:${this.id}_customVarName123:G` ) customUserInput = () => this.textOptionsSlot
    // creates...

  }]);
  return ExampleContentModel;
}(_baseContentmodel2.default), _class4._slots = {
  textSlot: "", // textarea
  richTextSlot: "RichText", // trix wysiwyg
  textOptionsSlot: "", // see _options
  numberSlot: 0, // text input, coerced to number
  booleanSlot: false, // checkbox
  referenceSlot: ExampleSubContentModel, // data-editable, contentModel mode
  referenceArraySlot: [ExampleSubContentModel] // data-editable, arrayAccessor mode
}, _temp4), (_descriptor4 = _applyDecoratedDescriptor(_class3.prototype, '_options', [_mobx.observable, _deepBindDecorator2.default], {
  enumerable: true,
  initializer: function initializer() {
    return {
      get textOptionsSlot() {
        // turns textOptionsSlot into dropdown
        return ["Option1", "Option2", "Option3"];
      }
    };
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class3.prototype, 'textSlot', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class3.prototype, 'richTextSlot', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class3.prototype, 'textOptionsSlot', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class3.prototype, 'numberSlot', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class3.prototype, 'booleanSlot', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor10 = _applyDecoratedDescriptor(_class3.prototype, 'referenceSlot', [_dec], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor11 = _applyDecoratedDescriptor(_class3.prototype, 'referenceArraySlot', [_dec2], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor12 = _applyDecoratedDescriptor(_class3.prototype, 'isCompleted', [_mobx.observable, _deepBindDecorator2.default], {
  enumerable: true,
  initializer: function initializer() {
    return {
      get variable() {
        return 'G:' + this.id + '_isCompleted:G';
      },
      defaultValue: false };
  }
}), _descriptor13 = _applyDecoratedDescriptor(_class3.prototype, 'userInput', [_mobx.observable, _deepBindDecorator2.default], {
  enumerable: true,
  initializer: function initializer() {
    return {
      get variable() {
        return 'G:' + this.id + '_userInput:G';
      },
      defaultValue: 100,
      value: "" };
  }
}), _descriptor14 = _applyDecoratedDescriptor(_class3.prototype, 'userInput_computed', [_mobx.observable, _deepBindDecorator2.default], {
  enumerable: true,
  initializer: function initializer() {
    return {
      get variable() {
        return 'G:' + this.id + '_userInput_computed:G';
      },
      get value() {
        if (!this.$inputStore) return "";
        var userInputVal = this.$inputStore.getInput(this, "userInput");
        return userInputVal + " was computed! (also gets saved, but is computed on UI), saves to variable: " + this["userInput_computed"].variable;
      }
    };
  }
}), _descriptor15 = _applyDecoratedDescriptor(_class3.prototype, 'customUserInput', [_mobx.observable, _deepBindDecorator2.default], {
  enumerable: true,
  initializer: function initializer() {
    return {
      get variable() {
        return 'G:' + this.id + '_customVarName123:G';
      },
      get defaultValue() {
        return this.textOptionsSlot;
      },
      value: ""
    };
  }
})), _class3));
exports.default = ExampleContentModel;


//////////////////
// WEBPACK FOOTER
// ./~/trc-example-activity/dist/contentmodel.js
// module id = ./node_modules/trc-example-activity/dist/contentmodel.js
// module chunks = 0